export default __webpack_public_path__ + "static/media/expand_less_black_24dp.9b6569a9.svg";